export const GLOBAL_OBN_AGENTS_RESET_STATE = 'GLOBAL_OBN_AGENTS_RESET_STATE';
export const GLOBAL_OBN_AGENTS_CURRENT_ITEM = 'GLOBAL_OBN_AGENTS_CURRENT_ITEM';

export const GLOBAL_OBN_AGENTS_REQUEST_LOADING = 'GLOBAL_OBN_AGENTS_REQUEST_LOADING';
export const GLOBAL_OBN_AGENTS_REQUEST_SUCCESS = 'GLOBAL_OBN_AGENTS_REQUEST_SUCCESS';
export const GLOBAL_OBN_AGENTS_REQUEST_FAILED = 'GLOBAL_OBN_AGENTS_REQUEST_FAILED';

export const GLOBAL_OBN_AGENTS_CURRENT_ACTION = 'GLOBAL_OBN_AGENTS_CURRENT_ACTION';
export const GLOBAL_OBN_AGENTS_RESET_ACTION = 'GLOBAL_OBN_AGENTS_RESET_ACTION';